// test971
(971 && 0);
